import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Drawer, IconButton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';

import chLogo from '~/assets/ch_logo.png';
import { routes } from '~/constants';

import Account from './Account';
import Navigation from './Navigation';

const SideBar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const isMobile = useMediaQuery('(max-width: 600px)');
  const theme = useTheme();
  const width = 300;

  const onMenuToggleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box component="aside" height="100vh">
      {isOpen && (
        <Drawer
          open={isOpen}
          variant="persistent"
          anchor="left"
          onClose={() => {
            setIsOpen(false);
          }}
          sx={{
            width: `${width}px`,
            '& .MuiDrawer-paper': {
              color: theme.palette.secondary[200],
              backgroundColor: theme.palette.background.alt,
              boxSizing: 'border-box',
              borderWidth: isMobile ? '2px' : 0,
              width: `${width}px`,
            },
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
            <Box sx={{ flexGrow: 1 }}>
              <Box sx={{ m: '9px 20px 5px 10px' }}>
                <Box display="flex" alignItems="center" gap="10px">
                  <IconButton onClick={onMenuToggleClick}>
                    <MenuIcon />
                  </IconButton>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexFlow: 'row nowrap',
                      gap: '10px',
                      '& img': { width: '40px' },
                    }}
                  >
                    <Link to={routes.ROOT}>
                      <h1>ФФЧ</h1>
                    </Link>
                    <img src={chLogo} />
                  </Box>
                </Box>
              </Box>
              <Navigation />
            </Box>
            <Account />
          </Box>
        </Drawer>
      )}
      <Box width="58px" height="100%">
        <Box
          sx={{
            width: '58px',
            height: '100%',
            position: 'fixed',
            left: 0,
            top: 0,
            backgroundColor: theme.palette.background.alt,
            p: '20px 20px 20px 10px',
          }}
        >
          <IconButton onClick={onMenuToggleClick}>
            <MenuIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default SideBar;
